export const USER_RIGHTS = {
  ADMIN: "admin",
  PERSONS: "persons",
  CONTRACTS: "contracts",
  ACCOUNTING: "accounting",
  INVOICES: "invoices",
  MATCHES: "matches",
  RESTAURANT: "restaurant",
  TRAINING: "training",
  MESSAGES: "messages",
  TAGS: "tags",
  DRAFTS: "drafts",
  EXTERNAL: "external",
  INVENTORY: "inventory",
  AUDIT: "audit",
} as const;

export type UserRight = typeof USER_RIGHTS[keyof typeof USER_RIGHTS];

export const USER_RIGHT_LABELS: Record<UserRight, string> = {
  [USER_RIGHTS.ADMIN]: "Administrator",
  [USER_RIGHTS.PERSONS]: "Personen verwalten",
  [USER_RIGHTS.CONTRACTS]: "Verträge einsehen",
  [USER_RIGHTS.ACCOUNTING]: "Buchhaltung (Buchungen, Abrechnung, SEPA)",
  [USER_RIGHTS.INVOICES]: "Rechnungen verwalten",
  [USER_RIGHTS.MATCHES]: "Spiele verwalten",
  [USER_RIGHTS.RESTAURANT]: "Restaurant verwalten",
  [USER_RIGHTS.TRAINING]: "Training verwalten",
  [USER_RIGHTS.MESSAGES]: "Nachrichten senden und empfangen",
  [USER_RIGHTS.TAGS]: "Tags verwalten",
  [USER_RIGHTS.DRAFTS]: "Kaderlisten verwalten",
  [USER_RIGHTS.EXTERNAL]: "Externer Zugang (Mitglied)",
  [USER_RIGHTS.INVENTORY]: "Inventar & Verleih verwalten",
  [USER_RIGHTS.AUDIT]: "Protokoll einsehen",
};
